import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
// import financialLoanImg from '../assets/images/financial_loan.jpg';
// import homeLoanImg from '../assets/images/home_loan.jpg';
import flexibleRepaymentImg from '../assets/images/flexible-repayment.jpg';
import minimalDocumentationImg from '../assets/images/minimal-documentation.jpg';
import quickApprovalImg from '../assets/images/quick-approval.jpg';
import secureTransparenImg from '../assets/images/secure-transparen.jpg';

import './whychoose-us.css';

const WhyChooseUs = () => {
  const features = [
    {
      title: 'Swift Loan Approval',
      text: 'Secure quick loan approval in just minutes through our seamless and hassle-free process.',
      img: quickApprovalImg,
    },
    {
      title: 'Flexible Repayment',
      text: 'Tailored repayment options that align seamlessly with your income and lifestyle.',
      img: flexibleRepaymentImg,
    },
    {
      title: 'Minimal Documentation',
      text: 'Skip the paperwork—just provide the essentials documents, simplified process.',
      img: minimalDocumentationImg,
    },
    {
      title: 'Secure & Transparent',
      text: 'No hidden charges, complete transparency in every step.',
      img: secureTransparenImg,
    },
  ];

  return (
    <section className="whychoose-us-section">
      <Container>
        <div className="whychoose-us-header text-center mb-5">
          <h2 className="whychoose-us-title">Why Choose Vanshika Micro Credit?</h2>
          <p className="whychoose-us-subtitle">
            At Vanshika Micro Credit, we prioritize simplicity, speed, and reliability in borrowing. Trusted by thousands, we are committed to supporting your financial needs with transparency and care.
          </p>
        </div>

        <Row className="g-4">
          {features.map((feature, idx) => (
            <Col sm={6} lg={3} key={idx}>
              <div className="whychoose-us-card">
                <img src={feature.img} alt={feature.title} className="whychoose-us-card-img" />
                <div className="whychoose-us-card-body">
                  <h5 className="whychoose-us-card-title">{feature.title}</h5>
                  <p className="whychoose-us-card-text">{feature.text}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default WhyChooseUs;
